<template>
  <label id="switch-button" :class="classObject" :style="styleObject">
    <input v-if="!disabled" type="checkbox" :style="styleObject" v-model="value" @click="e => $emit('click', e.target.checked)">
  </label>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    type: String,
    size: String,
    checked: Boolean,
    active: Boolean,
    customStyle: Object
  },
  data () {
    return {
      value: false
    }
  },
  computed: {
    classObject () {
      const { type, size, value, active, disabled } = this
      return {
        [`is-${type}`]: type,
        [`is-${size}`]: size,
        disabled: disabled,
        checked: value,
        active: active
      }
    },
    styleObject () {
      let defaultStyle = { cursor: this.disabled ? 'not-allowed' : 'pointer' }
      return { ...defaultStyle, ...(this.customStyle || {}) }
    }
  },
  mounted () {
    this.value = this.checked
  },
  watch: {
    checked () {
      this.value = this.checked
    },
    value (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss">
$grey-lighter: white;
$switch-colors: ("primary": (#f8B62D, #898989));
$switch-text: white;

#switch-button {
  --height: 18px;
  --scale: 2;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.16);

  input {
    opacity: 0;
    display: inline-block;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
  }

  appearance: none;
  position: relative;
  outline: 0;
  border-radius: calc(0.8 * var(--height));
  width: calc(var(--scale) * var(--height));
  height: var(--height);
  background-color: $grey-lighter;
  border: 1px solid #AAAAAA;

  box-sizing: border-box;
  display: inline-block;
  -webkit-tap-highlight-color: transparent;

  &:before,
  &:after {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    height: calc(var(--height) - 2px);
    border-radius: calc((var(--height) - 2px) / 2);
    transition: .233s;
  }

  &:before {
    width: calc(1.625 * var(--height) - 2px);
    background-color: $grey-lighter;
  }

  &:after {
    width: calc(var(--height) - 2px);
    background-color: #AAAAAA;
    box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1);
  }

  &.active {
    background-color: $grey-lighter;
    border: 1px solid #333333;
    &:before {
      transform: scale(0);
    }
    &:after {
      background-color: #83C91E;
    }
  }

  &.checked {
    background-color: $grey-lighter;
    border: 1px solid #333333;
    &:before {
      transform: scale(0);
    }
    &:after {
      background-color: #83C91E;
      transform: translateX(calc((var(--scale) - 1) * var(--height)));
    }
  }

  // Sizes
  &.is-small {
    --height: 12px
  }
  &.is-medium {
    --height: 24px
  }
  &.is-large {
    --height: 32px
  }
  &.is-short {
    --scale: 1.5
  }
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/switchButton.vue